import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import { CDN_ASSETS_LINK_BASE } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'

import { tID } from '../../utils/utils'
import { ImageComponentProps } from '../formElements/RadioButtons'
import { Image } from '../image/Image'

const HeadphonesSelfCareIllustrationImage = styled(Image)<{ width: number; height: number }>(({ width, height }) => ({
  width: `${width}px`,
  height: `${height}px`,
}))

export const HeadphonesSelfCareIllustration: FunctionComponent<ImageComponentProps> = ({
  width = 297,
  height = 193,
}) => {
  return (
    <HeadphonesSelfCareIllustrationImage
      source={`${CDN_ASSETS_LINK_BASE}/HeadphonesSelfCare.png`}
      testID={tID(`HeadphonesSelfCareIllustration`)}
      width={width}
      height={height}
    />
  )
}
